import {CardsContainer} from "./CardsContainer"
import {CardContainer} from "./CardContainer"

export const PlanetCardsStyled = {
    CardsContainer: CardsContainer,
    CardContainer: CardContainer
}